import { GetAppMetricsTimeSeriesAverageWholeTeamRequestDto } from '../../../interface/dtos/team-metrics/get-app-metrics-time-series-average-whole-team.request.dto';
import { GetAppMetricsTimeSeriesAverageWholeTeamResponseArray } from '../../../interface/dtos/team-metrics/get-app-metrics-time-series-average-whole-team.response.dto';
import { GetAppMetricsTimeSeriesAverageWholeTeamQuery } from '../../../interface/queries/team-metrics/get-app-metrics-time-series-average-whole-team.query';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { AppMetricsTimeSeriesAverageWholeTeamAggregateRootMapper } from '../../../infrastructure/mappers/team-metrics/app-metrics-time-series-average-whole-team.aggregate-root.mapper';

export class GetAppMetricsTimeSeriesAverageWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsTimeSeriesAverageWholeTeamQuery,
    protected readonly mapper: AppMetricsTimeSeriesAverageWholeTeamAggregateRootMapper
  ) {}

  async get(
    props: GetAppMetricsTimeSeriesAverageWholeTeamRequestDto
  ): Promise<GetAppMetricsTimeSeriesAverageWholeTeamResponseArray> {
    try {
      const result = await this.query.execute(props);
      return result.map((record) => this.mapper.toResponse(record));
    } catch (error) {
      throw new Error(
        `AppMetricsTimeSeriesAverageWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
